import { setOptOut } from '@amplitude/analytics-browser';

const onAccept = (): void => {
  if (typeof window !== 'undefined') {
    setOptOut(false);
  }
};

export default onAccept;
